import React from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { IMAGE_CARD_FRAME } from "data/guestLuxuryTheme";

const EventShowCard = ({ event, onClick }) => {
  if (!event) return null;

  return (
    <Box
      component={motion.button}
      type="button"
      onClick={onClick}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      sx={{
        appearance: "none",
        WebkitTapHighlightColor: "transparent",
        border: IMAGE_CARD_FRAME.border,
        bgcolor: "transparent",
        outline: "none",
        cursor: "pointer",
        width: "100%",
        p: 0,
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: IMAGE_CARD_FRAME.boxShadow,
        "&:focus": { outline: "none" },
        "&:active": { transform: "scale(0.985)" },
      }}
    >
      <Box
        component="img"
        src={event.image}
        alt={event.title}
        sx={{
          width: "100%",
          height: "auto",
          display: "block",
          verticalAlign: "middle",
        }}
      />
    </Box>
  );
};

export default EventShowCard;
